module.exports = __webpack_public_path__ + "static/img/how-it-work-3.5e695e2d.svg";